import { render, staticRenderFns } from "./OfertasOmil.vue?vue&type=template&id=0848e966&scoped=true&"
import script from "./OfertasOmil.vue?vue&type=script&lang=ts&"
export * from "./OfertasOmil.vue?vue&type=script&lang=ts&"
import style0 from "./OfertasOmil.vue?vue&type=style&index=0&id=0848e966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848e966",
  null
  
)

export default component.exports